import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  sidebarOpen: boolean;
  snackbar: { open: boolean; message: string; severity: 'success' | 'error' | 'info' | 'warning' };
  currentPage: string;
}

const initialState: UIState = {
  sidebarOpen: typeof window !== 'undefined' ? window.innerWidth > 900 : true,
  snackbar: { open: false, message: '', severity: 'success' },
  currentPage: 'dashboard',
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) { state.sidebarOpen = !state.sidebarOpen; },
    setSidebarOpen(state, action: PayloadAction<boolean>) { state.sidebarOpen = action.payload; },
    showSnackbar(state, action: PayloadAction<{ message: string; severity?: 'success' | 'error' | 'info' | 'warning' }>) {
      state.snackbar = { open: true, message: action.payload.message, severity: action.payload.severity || 'success' };
    },
    hideSnackbar(state) { state.snackbar.open = false; },
    setCurrentPage(state, action: PayloadAction<string>) { state.currentPage = action.payload; },
  },
});

export const { toggleSidebar, setSidebarOpen, showSnackbar, hideSnackbar, setCurrentPage } = uiSlice.actions;
export default uiSlice.reducer;
